module.exports = __webpack_public_path__ + "img/delete.96eba8a5.svg";